import { sumBy } from "lodash";
import type { OrderRegionBreakdownEntry } from "./statisticsApi";
import { formatEur, formatPercent } from "./statisticsFormat";

export interface RegionChartItem {
  readonly label: string;
  /** Slice size, in percent of the whole pie. */
  readonly sharePercent: number;
  readonly ordersCount: number;
  readonly detail?: string;
}

export function regionOrderShareItems(byRegion: OrderRegionBreakdownEntry[]): RegionChartItem[] {
  return byRegion.map((region) => ({
    label: region.regionName,
    sharePercent: region.ordersPercent,
    ordersCount: region.ordersCount,
  }));
}

/** Slices sized by each region's share of the total positive margin; regions without settled margin are left
 * out. */
export function regionMarginShareItems(byRegion: OrderRegionBreakdownEntry[]): RegionChartItem[] {
  const withMargin = byRegion.filter((region) => region.marginAmountEur !== null);
  const totalPositiveMargin = sumBy(withMargin, (region) => Math.max(region.marginAmountEur ?? 0, 0));
  return withMargin.map((region) => ({
    label: region.regionName,
    sharePercent: totalPositiveMargin > 0 ? (Math.max(region.marginAmountEur ?? 0, 0) / totalPositiveMargin) * 100 : 0,
    ordersCount: region.ordersCount,
    detail: `${formatEur(region.marginAmountEur)} · ${formatPercent(region.marginPercent)} marży`,
  }));
}
